import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/notification.service';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { PetDatesUtils } from 'src/app/shared/utils/dates.utils';
import { AtencionService } from 'src/core/atencion/atencion.service';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta } from 'src/core/consulta/consulta.types';
import { UserService } from 'src/core/user/user.service';
import { User } from 'src/core/user/user.types';

@Component({
  selector: 'app-solicitudes-citas',
  templateUrl: './solicitudes-citas.component.html',
  styleUrls: ['./solicitudes-citas.component.css']
})
export class SolicitudesCitasComponent  extends CommonComponent implements OnInit {
  userSession: User;
  consultas: Consulta[] = [];
  appointments: any[] = [];
  subscription: Subscription;
  sseStatusSubscription: Subscription;
  sseConnected = false;
  private mensaje: string = "tienes una nueva solicitud pendiente";

  constructor(
    private _userService: UserService,
    public _consultaService: ConsultaService,
    private _dateUtilsService: PetDatesUtils,
    private _atencionService: AtencionService,
    private notificationServicePush: NotificationService,
    _snackBar: MatSnackBar
  ){
    super(_snackBar);
  }

  ngOnInit(): void {
    /*if (this.subscription) {
      this.subscription.unsubscribe();
    }*/
    this.listenSseStatus();
    this.llamarSSe();
    this.getConsultas();
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.sseStatusSubscription) {
      this.sseStatusSubscription.unsubscribe();
    }
  }

  private listenSseStatus(): void {
    this.sseStatusSubscription = this._consultaService.sseStatus$.subscribe(status => {
      this.sseConnected = status;
    });
  }

  llamarSSe() {
    this.getUserSession();
   
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    
    this.subscription = this._consultaService.getAppointmentsStream(this.userSession.id)
      .subscribe({
        next: (consultas: Consulta[]) => {
          // console.log('Nuevo appointment recibido:', consultas);
          // console.log('cantidad de vainas:', consultas.length);
          if(consultas.length > 0 ){
            // console.log('paso con :', consultas.length);
            this.consultas = [];
            consultas.forEach((consulta) => {
              if(consulta.consultaEstadoCita == 1 ){
                consulta.showComponent = true;
                this.consultas.push(consulta);         
                   
              }
            });
            this.notificationServicePush.handleButtonClick(this.mensaje);
          }
          },error: (error) => {
          console.error('Error en la conexión con servidor de notificaciones:');
        }
      });
  }
  
  getConsultas(){   
    this._consultaService._consultasUsuarioVet$.subscribe({
      next: (consultas: Consulta[]) => {
        this.consultas = [];
        consultas.forEach((consulta) => {
          if(consulta.consultaEstadoCita == 1 ){
            consulta.showComponent = true;
            this.consultas.push(consulta);            
          }
        });
        //console.log(this.consultas);
        this.orderByDate('asc');
      },
      error: (error: any) => {        
        console.error('ERROR: - ', error.error.message);
        this.openSnackBar(error.error.message.toString());
      }
    });
  }

  searchEvt(event: any){
    var word = event.target.value?.toLowerCase();
    for(let i = 0; i < this.consultas.length; i++){
      if(this.consultas[i].consultaNombreAtencion.toLowerCase().includes(word) || word.length === 0){
        this.consultas[i].showComponent = true;
      }else{
        this.consultas[i].showComponent = false;
      }
    }
  }

  orderByDate( orden) {
    this.consultas = this.consultas.sort((a, b) => {

      const fechaA: Date = this._dateUtilsService.createDateFromDateAndTime(a.consultaFechaCita, a.consultaHoraCita);
      const fechaB: Date = this._dateUtilsService.createDateFromDateAndTime(b.consultaFechaCita, b.consultaHoraCita);

      if (orden === 'asc') {
        return fechaA.getTime() - fechaB.getTime();
      } else if(orden === 'desc') {
        return fechaB.getTime() - fechaA.getTime();
      }
    });
  }

  getUserSession() {
    this._userService.user_session$.subscribe({
      next: (user: User) => {
        this.userSession = user;
      }
    });
  }
}
